import api from "../../../api/catalogs/delay_event.js";
import _ from "lodash";
import { datePostShift, datePost } from "../../../filters.js";

const namespaced = true;

const state = {
    delay_event_data: [],
    delay_event_by_shift_data: [],
    loading: false,
    filter: 0,
    filterFailureType: [],
    filterArea: [],
    filterAreaSub: [],
    filterShift: [],
    timeDelay: 0,
    filterEquipment: [],
    filterComponent: [],
    day_selected: null,
    delay_event_is_planned: false,
    loading_store_delay: false,
    loading_complete_delay: false,
}
const mutations = {
    SET_DELAY_EVENT(state, data) {
        state.delay_event_data = data;
    },
    SET_LOADING(state, value) {
        state.loading = value;
    },
    ADD_DELAY_EVENT(state, value) {
        state.delay_event_data.unshift(value);
    },
    DELETE_DELAY_EVENT_COMPONENT(state, value) {
        state.delay_event_data.splice(
            _.findIndex(state.delay_event_data, function (o) {
                return o.id == value;
            }),
            1
        );
    },
    UPDATE_DELAY_EVENT_COMPONENT(state, value) {
        const newArr = _.clone(state.delay_event_data);
        const index = _.findIndex(state.delay_event_data, function (o) {
            return o.id == value.id;
        });
        if (index !== -1) {
            newArr[index] = value;
        }
        state.delay_event_data = newArr;
    },
    SET_FILTER(state, value) {
        state.filter = value;
    },
    SET_FILTER_FAILURE_TYPE(state, value) {
        state.filterFailureType = value;
    },
    SET_FILTER_AREA(state, value) {
        state.filterArea = value;
    },
    SET_FILTER_AREA_SUB(state, value) {
        state.filterAreaSub = value;
    },
    SET_FILTER_SHIFT(state, value) {
        state.filterShift = value;
    },
    SET_DELAY_EVENT_BY_SHIFT(state, value) {
        state.delay_event_by_shift_data = value;
    },
    SET_TIME_DELAY(state, value) {
        state.timeDelay = value;
    },
    SET_EQUIPMENT(state, value) {
        state.filterEquipment = value;
    },
    SET_COMPONENT(state, value) {
        state.filterComponent = value;
    },
    SET_DAY_SELECTED(state, value) {
        state.day_selected = value;
    },
    SET_DELAY_EVENT_IS_PLANNED(state, value) {
        state.delay_event_is_planned = value;
    },
    SET_LOADING_STORE_DELAY(state, value) {
        state.loading_store_delay = value;
    },
    SET_LOADING_COMPLETE_DELAY(state, value) {
        state.loading_complete_delay = value;
    },
};
const actions = {
    getDelayEvent(context) {
        context.commit("SET_LOADING", true);
        return new Promise((resolve) => {
            api.getDelayEvent().then(function (res) {
                context.commit("SET_DELAY_EVENT", res.data.data);
                context.commit("SET_LOADING", false);
                resolve(res.data);
            }).catch(function (error) {
                context.commit("SET_LOADING", false);
                console.log(error);
            });
        });
    },
    getDelayEventByShift(context, data) {
        context.commit("SET_LOADING", true);
        return new Promise((resolve) => {
            api.getByShift(data).then(function (res) {
                context.commit("SET_DELAY_EVENT_BY_SHIFT", res.data.data);
                context.commit("SET_LOADING", false);
                resolve(res.data);
            }).catch(function (error) {
                context.commit("SET_LOADING", false);
                console.log(error);
            });
        });
    },
    getDelayEventByDate(context, data) {
        context.commit("SET_LOADING", true);
        return new Promise((resolve) => {
            api.getByDates(data).then(function (res) {
                context.commit("SET_DELAY_EVENT", res.data.data);
                context.commit("SET_LOADING", false);
                resolve(res.data);
            }).catch(function (error) {
                context.dispatch("notifications/add", { color: "error", visibility: true, timeout: 5000, text: error, }, { root: true });
                context.commit("SET_DELAY_EVENT", []);
                context.commit("SET_LOADING", false);
                console.log(error);
            });
        });
    },
    getShowDelayEvent(context, data) {
        context.commit("SET_LOADING", true);
        return new Promise((resolve) => {
            api.getByDatesShow(data).then(function (res) {
                context.commit("SET_DELAY_EVENT", res.data.data);
                context.commit("SET_LOADING", false);
                resolve(res.data);
            }).catch(function (error) {
                context.dispatch("notifications/add", { color: "error", visibility: true, timeout: 5000, text: error, }, { root: true });
                context.commit("SET_DELAY_EVENT", []);
                context.commit("SET_LOADING", false);
                console.log(error);
            });
        });
    },
    store(context, data) {
        context.commit("SET_LOADING_STORE_DELAY", true);
        return new Promise((resolve) => {
            api.store(data).then(function (res) {
                context.commit("ADD_DELAY_EVENT", res.data.data);
                context.dispatch("notifications/add", { color: "success", visibility: true, timeout: 5000, text: res.data.message, }, { root: true });
                resolve(res.data);
                context.commit("SET_LOADING_STORE_DELAY", false);
            }).catch(function (error) {
                context.dispatch("notifications/add", { color: "error", visibility: true, timeout: 5000, text: error.messages, }, { root: true });
                context.commit("SET_LOADING_STORE_DELAY", false);
            });
        });
    },
    update(context, data) {
        return new Promise((resolve) => {
            api.update(data.id, data.data)
                .then(function (res) {
                    context.dispatch("notifications/add", { color: "success", visibility: true, timeout: 5000, text: res.data.message, }, { root: true });
                    context.commit("UPDATE_DELAY_EVENT_COMPONENT", res.data.data);
                    resolve(res.data);
                }).catch(function (error) {
                    context.dispatch("notifications/add", { color: "error", visibility: true, timeout: 5000, text: error.messages, }, { root: true });
                    console.log(error);
                });
        });
    },
    completeDelay(context, data) {
        return new Promise((resolve) => {
            context.commit("SET_LOADING_COMPLETE_DELAY", true);
            api.completeDelay(data.id, data.data).then(function (res) {
                context.dispatch("notifications/add", { color: "success", visibility: true, timeout: 5000, text: res.data.message, }, { root: true });
                context.commit("UPDATE_DELAY_EVENT_COMPONENT", res.data.data);
                resolve(res.data);
                context.commit("SET_LOADING_COMPLETE_DELAY", false);
            }).catch(function (error) {
                context.dispatch("notifications/add", { color: "error", visibility: true, timeout: 5000, text: error.messages, }, { root: true });
                console.log(error);
                context.commit("SET_LOADING_COMPLETE_DELAY", false);
            });
        });
    },
    delete(context, id) {
        return new Promise((resolve) => {
            api.deleteDelayEvent(id).then(function (res) {
                context.dispatch("notifications/add", { color: "success", visibility: true, timeout: 5000, text: res.data.message, }, { root: true });
                context.commit("DELETE_DELAY_EVENT_COMPONENT", id);
                resolve(res.data);
            })
                .catch(function (error) {
                    console.log(error);
                });
        });
    },
    storeByProduction(context, data) {
        return new Promise((resolve) => {
            api.storeByProduction(data).then(function (res) {
                context.dispatch("notifications/add", { color: "success", visibility: true, timeout: 5000, text: res.data.message, }, { root: true });
                resolve(res.data);
            }).catch(function (error) {
                context.dispatch("notifications/add", { color: "error", visibility: true, timeout: 5000, text: error.messages, }, { root: true });
            });
        });
    },
    setFilter(context, value) {
        context.commit("SET_FILTER", value);
    },
    setFilterFailureType(context, value) {
        context.commit("SET_FILTER_FAILURE_TYPE", value);
    },
    setFilterArea(context, value) {
        context.commit("SET_FILTER_AREA", value);
    },
    setFilterAreaSub(context, value) {
        context.commit("SET_FILTER_AREA_SUB", value);
    },
    setFilterShift(context, value) {
        context.commit("SET_FILTER_SHIFT", value);
    },
    setTimeDelay(context, value) {
        context.commit("SET_TIME_DELAY", value);
    },
    setEquipment(context, value) {
        context.commit("SET_EQUIPMENT", value);
    },
    setComponent(context, value) {
        context.commit("SET_COMPONENT", value);
    },
    setDaySelected(context, value) {
        context.commit("SET_DAY_SELECTED", value);
    },
    resetDataDelayEvent(context) {
        context.commit('SET_DELAY_EVENT', []);
    },
    setDelayEventIsPlanned(context, value) {
        context.commit('SET_DELAY_EVENT_IS_PLANNED', value);
    }
};

const getters = {
    getDelayEventData(state) {
        const filteredEvents = _.filter(state.delay_event_data, (event) => {
            const failureTypeId = event.equipmentFailure.origin === "Equipo General" ? event.equipmentFailure.type.id : event.equipmentFailure.failure_type_name.id;
            const failureTypeMatch = _.some(state.filterFailureType, { id: failureTypeId, });
            const equipmentMatch = _.some(state.filterEquipment, { id: event.equipment.id, });
            const productionAreaMatch = _.some(state.filterArea, { id: event.equipment.sub_area.production_area_id, });
            const subAreaMatch = _.some(state.filterAreaSub, { id: event.sub_area.id, });
            const componentMatch = _.some(state.filterComponent, { name: event.equipmentComponent.name, });
            const shiftMatch = event.shifts.length === 0 ? true : _.some(event.shifts, (shift) => _.some(state.filterShift, { name: shift.name }));
            return (failureTypeMatch && equipmentMatch && productionAreaMatch && subAreaMatch && componentMatch && shiftMatch)
        });
        return _.orderBy(_.filter(filteredEvents, function (o) { return o.time_stop > state.timeDelay; }), ["id"], ["desc"]);
    },

    getNewDelayEventData(state) {
        return state.delay_event_data;
    },
    getDelayEventDataCount(state) {
        return state.delay_event_data.length;
    },
    getDelayEventDataByShift(state) {
        const filteredEvents = _.filter(
            state.delay_event_by_shift_data,
            (event) => {
                const failureTypeId =
                    event.equipmentFailure.origin === "Equipo General"
                        ? event.equipmentFailure.type.id
                        : event.equipmentFailure.failure_type_name.id;
                const failureTypeMatch = _.some(state.filterFailureType, {
                    id: failureTypeId,
                });
                const equipmentMatch = _.some(state.filterEquipment, {
                    id: event.equipment.id,
                });
                const productionAreaMatch = _.some(state.filterArea, {
                    id: event.equipment.sub_area.production_area_id,
                });
                const subAreaMatch = _.some(state.filterAreaSub, {
                    id: event.sub_area.id,
                });
                const shiftMatch = !event.shift
                    ? true
                    : _.some(state.filterShift, { name: event.shift.name });

                return (
                    failureTypeMatch &&
                    equipmentMatch &
                    productionAreaMatch &
                    subAreaMatch &
                    shiftMatch
                );
            }
        );

        return _.orderBy(
            _.filter(filteredEvents, function (o) {
                return parseInt(o.minutes_shift_date) > state.timeDelay;
            }),
            ["id"],
            ["desc"]
        );
    },
    getDelayEventDataByShiftCount(state) {
        return state.delay_event_by_shift_data.length;
    },
    getDelayEventDataOpen(state) {
        return _.filter(state.delay_event_data, function (o) {
            return o.status_id.id == 1;
        });
    },
    getDelayEventDataClosed(state) {
        return _.filter(state.delay_event_data, function (o) {
            return o.status_id.id == 2;
        });
    },
    getDelayEventExport(state, getter) {
        let transformData = _.map(getter.getDelayEventData, (item) => [
            item.plant.name,
            item.id,
            item.equipment.sub_area.area,
            item.sub_area.name,
            item.equipment.code,
            item.equipment.name,
            item.equipmentComponent.description,
            item.equipmentFailure.origin == "Particular"
                ? item.equipmentFailure.failure_type_name.name
                : item.equipmentFailure.type.name,
            item.equipmentFailure.description,
            item.start_event_date.split(" ")[0],
            item.start_event_date.split(" ")[1],
            datePost(item).split(" ")[0],
            item.end_event_date.split(" ")[1],
            _.join(_.map(item.shifts, "name"), ", "),
            item.time_stop,
        ]);
        return transformData;
    },
    getDelayEventByShiftExport(state, getter) {
        let transformData = _.map(getter.getDelayEventDataByShift, (item) => [
            item.plant.name,
            item.id,
            item.equipment.sub_area.area,
            item.sub_area.name,
            item.equipment.code,
            item.equipment.name,
            item.equipmentComponent.description,
            item.equipmentFailure.origin == "Particular"
                ? item.equipmentFailure.failure_type_name.name
                : item.equipmentFailure.type.name,
            item.equipmentFailure.description,
            item.shift.date,
            item.shift.shift_start,
            datePostShift(item.shift).split(' ')[0],
            item.shift.shift_end,
            item.shift.name,
            item.minutes_shift_date,
        ]);
        return transformData;
    },
    getAreaSubSelect(state) {
        return _.flatMap(state.filterArea, "subAreas");
    },
    getDelayEventCalendar(state, getter) {
        const DelayEvents = (state.delay_event_is_planned) ? getter.getDelayEventData : _.filter(getter.getDelayEventData, { 'is_planned': "Si" })
        return DelayEvents.map((event) => {

            return {
                name: `No. Demora ${event.id} ${event.start_event_date.split(" ")[1]
                    } a ${event.end_event_date.split(" ")[1]}`,
                id: event.id,
                start: new Date(event.start_event_date),
                end: new Date(event.end_event_date),
                color: event.is_planned === "Si" ? "warning" : "yellow",
                area: event.equipment.sub_area.area,
                subarea: event.sub_area.name,
                equipment: event.equipment.name,
                type_failure: event.equipmentFailure.origin == "Particular" ? event.equipmentFailure.failure_type_name.name : event.equipmentFailure.type.name,
                failure: event.equipmentFailure.description,
                time_start: event.start_event_date.split(" ")[1],
                time_end: event.end_event_date.split(" ")[1],
                shift: _.join(_.map(event.shifts, "name"), ", "),
                time: event.time_stop,
                timed: true,
            };
        });
    },
};

export default {
    namespaced,
    state,
    mutations,
    actions,
    getters,
};
